import React, { FC, useState } from 'react';
import { LuMoon, LuSun, LuMenu, LuX } from 'react-icons/lu';
import { useActiveSection } from '../hooks/useActiveSection';
import type { Theme } from '../hooks/useTheme';

export const sections = [
  { id: 'inicio', label: 'Início' },
  { id: 'sobre', label: 'Sobre' },
  { id: 'servicos', label: 'Serviços' },
  { id: 'apps', label: 'Apps' },
  { id: 'projetos', label: 'Projetos' },
  { id: 'contato', label: 'Contato' },
];

const Navbar: FC<{ theme: Theme; onToggle: () => void }> = ({ theme, onToggle }) => {
  const [open, setOpen] = useState(false);
  const active = useActiveSection(sections.map((s) => s.id));

  return (
    <header className="nav">
      <div className="container nav__inner">
        <a href="#inicio" className="nav__brand" onClick={() => setOpen(false)}>
          <img src={`${process.env.PUBLIC_URL}/bruno.png`} alt="" width={32} height={32} />
          <span>
            Bruno<span className="accent">.dev</span>
          </span>
        </a>

        <nav className={`nav__links ${open ? 'is-open' : ''}`} aria-label="Principal">
          {sections.map((s) => (
            <a
              key={s.id}
              href={`#${s.id}`}
              className={active === s.id ? 'is-active' : ''}
              aria-current={active === s.id ? 'true' : undefined}
              onClick={() => setOpen(false)}
            >
              {s.label}
            </a>
          ))}
        </nav>

        <div className="nav__actions">
          <button
            type="button"
            className="icon-btn"
            onClick={onToggle}
            aria-label={theme === 'dark' ? 'Ativar tema claro' : 'Ativar tema escuro'}
            title={theme === 'dark' ? 'Tema claro' : 'Tema escuro'}
          >
            {theme === 'dark' ? <LuSun size={18} /> : <LuMoon size={18} />}
          </button>
          <button
            type="button"
            className="icon-btn nav__burger"
            onClick={() => setOpen((o) => !o)}
            aria-label={open ? 'Fechar menu' : 'Abrir menu'}
            aria-expanded={open}
          >
            {open ? <LuX size={20} /> : <LuMenu size={20} />}
          </button>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
